module.exports = __webpack_public_path__ + "static/87-1-021f2bccbeefc24feebeae96268ef1d4.jpg";